import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { useGlobal } from '../contexts/GlobalContext';

const FarcasterPreferencesSection = ({ onUpdate, boostInput = false }) => {
  const { defaultFarcasterUserId } = useGlobal();
  const [currentUserId, setCurrentUserId] = useState(defaultFarcasterUserId || '');
  const [currentUserPreference, setCurrentUserPreference] = useState('');
  const [boost, setBoost] = useState(1);

  const userPreferenceOptions = [
    { id: 'primary_labels', label: 'Primary Labels' },
    { id: 'secondary_labels', label: 'Secondary Labels' },
    { id: 'primary_clusters', label: 'Primary Clusters' },
    { id: 'secondary_clusters', label: 'Secondary Clusters' }
  ];

  const handleUserPreferenceAction = (actionType) => {
    if (!currentUserId.trim() || !currentUserPreference) return;
    
    // Determine target field based on preference type
    let targetField;
    if (currentUserPreference.includes('labels')) {
      targetField = 'ai_labels_med';
    } else if (currentUserPreference.includes('clusters')) {
      targetField = 'cluster_id';
    }
    
    const updateData = {
      action: actionType,
      filter: 'terms_lookup',
      lookup_index: 'farcaster-users',
      value: currentUserId.trim(),
      field: targetField,
      path: currentUserPreference
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    // Reset after adding
    setCurrentUserPreference('');
    setCurrentUserId(defaultFarcasterUserId || '');
  };

  return (
    <Box>
      <TextField
        label="User ID"
        value={currentUserId}
        onChange={(e) => setCurrentUserId(e.target.value)}
        placeholder="Enter user ID"
        helperText="e.g., 123"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>User Preference</InputLabel>
        <Select
          value={currentUserPreference}
          label="User Preference"
          onChange={(e) => setCurrentUserPreference(e.target.value)}
        >
          {userPreferenceOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUserPreferenceAction('include')}
          disabled={!currentUserId.trim() || !currentUserPreference}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleUserPreferenceAction('boost')}
            disabled={!currentUserId.trim() || !currentUserPreference}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleUserPreferenceAction('exclude')}
          disabled={!currentUserId.trim() || !currentUserPreference}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default FarcasterPreferencesSection;
